import React from 'react';
import classNames from 'classnames';
import { getCellModifierByType, getTitleByType } from '../enums';

const LeaderboardCellTitleBasic = (
    {
        type,
        sortingHandler,
        processingState
    }
) => {
    const isActive = processingState.sortingType === type;
    const stateCss = classNames({
        'is-active': isActive,
        'is-top': isActive && processingState.isSortingAscending
    });

    const modifier = getCellModifierByType(type);
    const title = getTitleByType(type);

    return (
        <div
            className={`leaderboard__cell leaderboard__cell--title leaderboard__cell--${modifier} ${stateCss}`}>
            <button
                className="leaderboard__cell-content-title"
                type="button"
                onClick={() => sortingHandler(type)}
            >
                <div className="leaderboard__cell-title">{title}</div>
                <div className="leaderboard__cell-title-icon-wrapper">
                    <svg className="leaderboard__cell-title-icon icon" width="9" height="6" focusable="false">
                        <use xlinkHref="#icon-triangle"></use>
                    </svg>
                </div>
            </button>
            <div className="leaderboard__cell-title-m">{title}</div>
        </div>
    );
};

export default LeaderboardCellTitleBasic;
